import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {Platform} from 'react-native';

let ToastAndroid;
if (Platform.OS === 'android' || Platform.OS === 'ios') {
  ToastAndroid = lazy(() => import('react-native'));
}

export const authApi = async (mobileNumber, otp) => {
  const response = await axios.post('https://creato-api.arohalabs.tech/astro/auth/login', {
    mobileNumber,
    otp,
  }, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const sendOTP = async (mobileNumber) => {
  const response = await axios.post('https://creato-api.arohalabs.tech/astro/auth/send-otp', {
    mobileNumber,
  }, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if(response.data.data.message === "Success"){
    ToastAndroid.show('OTP sent successfully', ToastAndroid.LONG);
  }
  else{
    ToastAndroid.show('Failed to send OTP. Please try again.', ToastAndroid.LONG);
  }
};

export const sendMessage = async (message) => {
    const value = await AsyncStorage.getItem('user');
    const authenticationToken = JSON.parse(value)
    const url = 'https://creato-api.arohalabs.tech/astro/chat';
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authenticationToken.authToken}`
    };
    const data = message;
    
    try {
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.error;
      if (errorMessage) {
        ToastAndroid.show(errorMessage, ToastAndroid.LONG);
      }
      throw error;
    }
  };

  export const updateUserInfo = async (userData) => {
    const url = 'https://creato-api.arohalabs.tech/astro/user';
    const value = await AsyncStorage.getItem('user');
    const authenticationToken = JSON.parse(value)
    const data = userData;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authenticationToken.authToken}`
      },
    };
    try {
      const response = await axios.put(url, data, config);
      if(response?.data?.data){
        const userdata ={
            id: response?.data?.data?.id,
            name: response?.data?.data?.name,
            phoneNumber: response?.data?.data?.mobile,
            authToken: response?.data?.data?.token,
            birthDate: response?.data?.data?.birth_date,
            birthPlace: response?.data?.data?.birth_place,
            birthTime: response?.data?.data?.birth_time,
            gender: response?.data?.data?.gender,
            profileImage: response?.data?.data?.profile_image,
            firstTime: response?.data?.data?.first_time,
            userBalance: response?.data?.data?.coins ?? 0,
        }
        await AsyncStorage.setItem("user", JSON.stringify(userdata));
      }
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.error;
      if (errorMessage) {
        ToastAndroid.show(errorMessage, ToastAndroid.LONG);
      }
    }
  };

  export const fetchHoroscope = async () => {
    try {
      const value = await AsyncStorage.getItem('user');
      const authenticationToken = JSON.parse(value);
      const url = 'https://creato-api.arohalabs.tech/astro/horoscope';
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authenticationToken.authToken}`,
      };
  
      const response = await axios.get(url, { headers });
      console.log(response, 'response.data');
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.error;
      if (errorMessage) {
        ToastAndroid.show(errorMessage, ToastAndroid.LONG);
      }
    }
  };

